// src/components/sections/OurPartners.styles.js

const styles = {
  section: (isDarkMode) => ({
    padding: '3rem 0',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: isDarkMode ? '#111827' : '#f9fafb',
  }),

  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
  },

  header: {
    textAlign: 'center',
    marginBottom: '3rem',
  },

  heading: (isDarkMode) => ({
    fontSize: 'clamp(1.5rem, 3vw, 2rem)',
    fontWeight: 700,
    marginBottom: '0.5rem',
    color: isDarkMode ? '#f9fafb' : '#1f2937',
    position: 'relative',
    display: 'inline-block',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '50px',
      height: '3px',
      backgroundColor: '#3b82f6',
      borderRadius: '2px'
    }
  }),

  partnersRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3rem',
    marginBottom: '2rem',
    // Make it responsive with flex-wrap
    '@media (max-width: 768px)': {
      gap: '2rem',
    }
  },

  partnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexBasis: '150px',
    transition: 'transform 0.3s ease',
  },

  logoWrapper: (isDarkMode) => ({
    width: '100%',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Light background in both modes to make dark logos visible
    backgroundColor: isDarkMode ? '#ffffff' : '#ffffff',
    borderRadius: '1rem',
    padding: '1rem',
    boxShadow: isDarkMode 
      ? '0 4px 6px -1px rgba(255, 255, 255, 0.1), 0 2px 4px -1px rgba(255, 255, 255, 0.05)' 
      : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transition: 'all 0.3s ease',
    // Subtle border in dark mode
    border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
  }),

  logoImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    transition: 'transform 0.3s ease',
  },
  
  // New style for dark mode logo visibility
  darkModeLogo: {
    // No filter needed as we're using a white background
    // Add a subtle drop shadow to help with contrast if needed
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))',
  }
};

export default styles;